import PageLayout from '@/shared/components/PageLayout';
import {PAGE_NAME, STATUS_BAR_COLOR} from '@/shared/constants/statusBarColor';

const HomeSkeleton = () => {
  return (
    <PageLayout
      title="홈"
      tiara={false}
      className="container-home type_skeleton"
      statusBarColor={{default: STATUS_BAR_COLOR[PAGE_NAME.HOME]}}
      headerProps={{title: '톡디지털카드', buttons: [{type: 'CLOSE'}, {type: 'SETTING'}]}}
    >
      <div className="inner_g">
        <ul className="list_card">
          <li className="item_card"></li>
          <li className="item_card"></li>
          <li className="item_card"></li>
          <li className="item_card"></li>
        </ul>
        <button type="button" className="btn_more"></button>
        <ul className="list_recommend">
          <li className="item_recommend"></li>
          <li className="item_recommend"></li>
          <li className="item_recommend"></li>
        </ul>
        <button type="button" className="btn_more"></button>
      </div>
    </PageLayout>
  );
};

export default HomeSkeleton;
